/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is mad                    letterSpacing: "0.15px",
                    color: checkPurgeData ? "#5A5B5C" : "#00000061",
                  }}
                >
                  All user's applications will be uninstalled from the devices.ilable solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { Checkbox } from "@mui/material";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { deleteUser } from "../../../../Services/redux/global-admin-users/GlobalAdminUsersActions";
import ApplicationDetailsErrorDialog from "../../../../Components/ApplicationDetailsErrorDialog/ApplicationDetailsErrorDialog";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function DeleteUserModal({
  openDeleteUserModal,
  handleDeleteUserClose,
  setAnchorEl,
  currentTabStatus,
  selectedRowId,
  searchTerm,
}) {
  const dispatch = useDispatch();
  const [checkForceUninstall, setCheckForceUninstall] = useState(false);
  const [checkPurgeData, setCheckPurgeData] = useState(false);
  const errors = useSelector((state) => state.errors);
  
  useEffect(() => {
    if (!openDeleteUserModal) {
      setCheckForceUninstall(false);
      setCheckPurgeData(false);
    }
  }, [openDeleteUserModal]);

  const toggleForceUninstallCheck = (event) => {
    setCheckForceUninstall(event.target.checked);
  };

  const togglePurgeDataCheck = (event) => {
    setCheckPurgeData(event.target.checked);
    // Reset Force Uninstall when Purge Data is unchecked
    if (!event.target.checked) {
      setCheckForceUninstall(false);
    }
  };

  const handleDeleteUser = () => {
    const refetchPayload = {
      status: [currentTabStatus],
    };

    const trimmedSearchTerm = searchTerm?.trim();
    if (trimmedSearchTerm) {
      refetchPayload.email = [trimmedSearchTerm];
    }

    // Close the action-menu anchor immediately to avoid stale anchor positioning.
    setAnchorEl(null);

    Promise.resolve(
      dispatch(
        deleteUser(
          selectedRowId,
          checkPurgeData,
          checkForceUninstall,
          refetchPayload
        )
      )
    ).then((deleteResult) => {
      if (deleteResult?.success === false) {
        return;
      }
      
      handleDeleteUserClose();
    });
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleDeleteUserClose}
        aria-labelledby="customized-dialog-title"
        open={openDeleteUserModal}
        slotProps={{
          paper: {
            sx: {
              width: "423px",
              minHeight: "196px",
              borderRadius: "8px",
              padding: "24px",
              display: "flex",
              gap: "24px",
            },
          },
        }}
      >
        <Box
          sx={{
            minWidth: "375px",
            minHeight: "88px",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
        >
          <div>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "18px",
                lineHeight: "24px",
                letterSpacing: "0.15px",
                color: "#121415",
              }}
            >
              Delete User
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleDeleteUserClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
          </div>

          <Box
            sx={{
              maxWidth: "423px",
              minHeight: "18px",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <Typography
              sx={{
                width: "375px",
                height: "40px",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "140%",
                letterSpacing: "0.15px",
                color: "#5A5B5C",
              }}
            >
              Please confirm that user account deanna.curtis should be deleted.
              This action can not be reversed.
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: "8px",
                maxWidth: "373px",
                minHeight: "62px",
                alignItems: "flex-start",
              }}
            >
              <Checkbox
                checked={checkPurgeData}
                onChange={togglePurgeDataCheck}
                color="primary"
              />

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                  maxWidth: "349px",
                  minHeight: "62px",
                }}
              >
                <Typography
                  sx={{
                    width: "182px",
                    height: "20px",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "20px",
                    letterSpacing: "0.25px",
                    verticalAlign: "middle",
                    textWrap: "nowrap",
                    color: "#000000DE",
                  }}
                >
                  Purge All Data
                </Typography>
                <Typography
                  sx={{
                    width: "349px",
                    minHeight: "40px",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "140%",
                    letterSpacing: "0.15px",
                    color: "#5A5B5C",
                  }}
                >
                  Purge all data related to user's account.
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: "8px",
                maxWidth: "373px",
                minHeight: "62px",
                alignItems: "flex-start",
                opacity: checkPurgeData ? 1 : 0.5,
                pointerEvents: checkPurgeData ? "auto" : "none",
              }}
            >
              <Checkbox
                checked={checkForceUninstall}
                onChange={toggleForceUninstallCheck}
                disabled={!checkPurgeData}
                color="primary"
              />

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                  maxWidth: "349px",
                  minHeight: "62px",
                }}
              >
                <Typography
                  sx={{
                    width: "182px",
                    height: "20px",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "20px",
                    letterSpacing: "0.25px",
                    verticalAlign: "middle",
                    color: checkPurgeData ? "#000000DE" : "#00000061",
                  }}
                >
                  Force Uninstall Application
                </Typography>
                <Typography
                  sx={{
                    width: "349px",
                    minHeight: "40px",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "140%",
                    letterSpacing: "0.15px",
                    color: "#5A5B5C",
                  }}
                >
                  All user’s applications will be uninstalled from the devices.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <DialogActions>
          <Button
            sx={{
              textTransform: "none",
            }}
            variant="outlined"
            onClick={handleDeleteUserClose}
          >
            Cancel
          </Button>
          <Button
            sx={{
              textTransform: "none",
              color: "#B50B00",
              borderColor: "#B50B00",
            }}
            variant="outlined"
            onClick={handleDeleteUser}
          >
            Delete
          </Button>
        </DialogActions>
      </BootstrapDialog>

       {/* Error Dialog */}
            {errors?.errorMessage && errors?.errorType && (
              <ApplicationDetailsErrorDialog />
            )}
            </>
  );
}

DeleteUserModal.propTypes = {
  openDeleteUserModal: PropTypes.bool,
  handleDeleteUserClose: PropTypes.func,
  setAnchorEl: PropTypes.func,
  currentTabStatus: PropTypes.string,
  selectedRowId: PropTypes.string,
  searchTerm: PropTypes.string,
};
